import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_165: DocMigration = {
  maxSchemaVersion: "0.0.165",
  description: "Add support for annotation linework offsets",
  apply(json: any) {
    for (const annotationId in json.annotation) {
      const annotation = json.annotation[annotationId];

      if (annotation.type === "LINEWORK") {
        const shapes = annotation.shapes || {};

        for (const shapeId in shapes) {
          shapes[shapeId] = lineworkShapeNew(shapes[shapeId]);
        }
      }
    }

    return json;
  },
};

function lineworkShapeNew({
  path,
  name = "",
  lineType = "CONTINUOUS",
  lineWeight = 1,
  offset = false,
  offsetDim = 5,
  fillThickness = 8,
  offsetLineType = "CONTINUOUS",
  offsetFillType = "NONE",
}) {
  return {
    path,
    name,
    lineType,
    lineWeight,
    offset,
    offsetDim,
    fillThickness,
    offsetLineType,
    offsetFillType,
  };
}

export default migration_0_0_165;
